export default __webpack_public_path__ + "static/rscBtn-e216794987c761772e34c19234522a0f.jpg";